import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { Component } from "@angular/core";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { NgClass, NgForOf } from "@angular/common";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { TooltipModule } from "@cloudfactorydk/ng2-tooltip-directive";

export interface FaLinkIcon {
  icon: IconDefinition
  link: string
  css_classes: string
  tooltip?: string
}

@Component({
  selector: 'ag-grid-fa-symbol-link-renderer',
  template: `
    <div style="display: inline-flex; flex-direction: row;">
      <a *ngFor="let link_icon of linkIcons" style="cursor: pointer; margin-right: 6px;" target="_blank" 
         [href]="link_icon.link" [ngClass]="link_icon.css_classes" [tooltip]="link_icon.tooltip"
         (click)="$event.stopPropagation()">
        <fa-icon [icon]="link_icon.icon"></fa-icon>
      </a>
    </div>
  `,
  imports: [
    FaIconComponent,
    NgForOf,
    NgClass,
    TooltipModule
  ],
  standalone: true
})
export class AgGridFASymbolLinkRenderer implements ICellRendererAngularComp {

  linkIcons: FaLinkIcon[] = [];

  agInit(params: ICellRendererParams<{links: FaLinkIcon[]}, FaLinkIcon[], any>): void {
    this.linkIcons = params.value
  }

  refresh(params: ICellRendererParams<{links: FaLinkIcon[]}, FaLinkIcon[], any>): boolean {
    this.linkIcons = params.value
    return true;
  }

}